import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { setAutoCheckedIn, setSelfieVideo } from '../../action/autoCheckin';
import { setGoHome } from '../../action/homeAction';
import { CMSPath, ENABLEDIGITALKEY } from '../../../config/constant';
import { mobileCheckinColorConfig } from '../../JS/colorConfig'
import { sendConfidenceScore } from '../../action/autoCheckin';
import moment from 'moment';
import {withTranslation} from 'react-i18next'
import { getDefaultAnalyticsLabel } from '../../JS/utility';
import doorKeySvg from "./assets/ico_generic_doorkey.svg";

class BookingSuccess extends Component{

    userNameHandler = (resp) => {
        let name = null;
        if(resp){
            resp.forEach((obj) => {
                if(obj.key == "Name"){
                    name = obj.value
                }
            });
        }

        return name;
    }

    getObject(key,arr=this.props.idCardResponse.fields) {
        console.log('id card response', arr);
        let obj = {}
        for (obj of arr){
          if (obj.key == key){
            return obj;
          }
        }
        return obj;
      }



    componentDidMount() {
        window.scrollTo(0,0);
        mobileCheckinColorConfig(this.props.menuColor);


        if(!this.props.selfieVideo || !this.props.selfieVideo.videoUrl){
            if(localStorage.getItem("selfieVideoUrl")){
                this.props.setSelfieVideo({videoUrl: localStorage.getItem("selfieVideoUrl")});
            }
        }

        // Shifted this to confidence show page
        // let currentDateTime = moment();

        // let label = {...getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""}),
        //         "dateTime": currentDateTime,
        //         "guestIdentifier": this.getObject("Country Code").value,
        //         "layoutTab": this.props.currentHomePage.tabName, "element": "widget", 
        //         "pageName": "Booking Success", "widgetSessionId": localStorage.getItem("checkinSessionToken")
        //     }
        // this.props.sendConfidenceScore(
        //     this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
        //     "GUEST ID VALIDATION SCORE",
        //     {...label, "scoreValue": this.props.idCardResponse.type.confidence,
        //     "valueSetFromCMSAsMinimumValue":this.props.confidenceScores.guestIDValidation}
        // );

        // this.props.sendConfidenceScore(
        //     this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
        //     "GUEST SELFIE LIVELINESS_SCORE",
        //     {...label, "scoreValue": this.props.selfieResponse.selfie.live,
        //     "valueSetFromCMSAsMinimumValue":this.props.confidenceScores.guestSelfieLiveliness}
        // );

        // this.props.sendConfidenceScore(
        //     this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
        //     "GUEST PHOTO MATCHING SCORE",
        //     {...label, "scoreValue": this.props.selfieResponse.selfie.match,
        //     "valueSetFromCMSAsMinimumValue":this.props.confidenceScores.guestPhotoMatching},
        // );

    }
    
    render(){
        const {t} = this.props
        return(
            <div className="main-container" style={{background: "url('theme/images/background/08MEDubai-Atrium.jpg')", backgroundSize: 'cover',backgroundAttachment: 'fixed'}}>
                <header className="inner-pages w-footer subpages">
                    <a onClick={() => this.props.setGoHome(true)} className="button-back"></a>
                    <div className="heading align-center">
                        <div class="splash-brand">
                            <img src={`${CMSPath}${this.props.logo}`} />
                        </div>
                        {/* <p className="bold" style = {{color:"inherit"}}>{t('check_in.guest_checkin')}</p> */}
                    </div>
                </header>
                <section className="widgets padding-0 margin-0 container-bg">

                    <div class="widget-header widget-header-checkin-inner checkin-success">
                        { this.props.currentWidgetObj.widgetHeaderImageUrl && 
                            <div class="widget-header-img">
                                <img src={`${CMSPath}${this.props.currentWidgetObj.widgetHeaderImageUrl}`} alt={this.props.currentWidgetObj.displayName} />
                            </div>
                        }
                        <div class="widget-header-title">{t('check_in.guest_checkin')}</div>
                    </div>

                    <div className="widgets">
                        {
                            !process.env.REACT_APP_NEWER_DESIGN=="true"&& 
                             <div className="row padding-top-1 padding-bottom-0 padding-right-1 padding-left-1">
                                <h2 className = "all-caps">{t('check_in.success')}</h2>
                             </div> 
                        }
                         
                        <div className="form-window">
                            {
                                 !process.env.REACT_APP_NEWER_DESIGN=="true" &&
                                    <div className="form-window-heading">
                                         {t('check_in.thank_you')}
                                     </div>  
                            }   
                            
                            <div className="row padding-top-1 padding-right-1 padding-left-1">
                                <div className="form-row form-status">
                                    <div className="form-status-icon success">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 333.33 237.59"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path className="cls-1" d="M328.32,5h0a17.13,17.13,0,0,0-24.21,0l-191.5,191.5L29.22,113.13a17.13,17.13,0,0,0-24.21,0H5a17.13,17.13,0,0,0,0,24.21l95.25,95.25a17.74,17.74,0,0,0,24.69,0L328.32,29.22A17.13,17.13,0,0,0,328.32,5Z"/></g></g></svg>
                                    </div>

                                    {
                                        process.env.REACT_APP_NEWER_DESIGN=="true" && 
                                            <div class ="header" dangerouslySetInnerHTML={{ __html :"CHECK-IN <br/> COMPLETE" }}></div>
                                    }

                                    <div className="form-status-text">{t('check_in.success_msg')}</div>
                                </div>
                            </div>
                            <div className="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                                <div className="form-row margin-bottom-1 room-info">
                                    <label for="bookingNum">{t('check_in.room')}</label>
                                    <input name="bookingNum" id="bookingNum" type="text" value = {this.props.checkinRoomNo} readOnly />
                                </div>
                                <div className="form-row margin-bottom-1">
                                    {localStorage.getItem("isDoorKeyInLayout") == "true" ? <p>{t('check_in.digital_key_msg1')} <img src={doorKeySvg} style={{width:"1.3rem", height:"1rem"}} alt='door_key' />{t('check_in.digital_key_msg2')}</p> /* Hide when hotel locks support virtual door key */
                                    : <p>{t('check_in.key_from_desk')}</p>}
                                </div>
                                <div className="form-controls">
                                    <Link exact to="/checkin/profile_photo">  
                                        <button className="primary w-100" >{t('check_in.close')}</button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </section>
            </div>
        );
    }
}

const getConfidenceConfig = (state) => {
    try {
      return state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.confidenceScores;
    } catch (error) {
      // alert("Error in fetching confidence score config from hotel.");
      return {guestIDValidation: 10, guestPhotoMatching: 10, guestSelfieLiveliness: 10};
    }
  }

const mapStateToProps = state => {
    return{
        idCardResponse: state.store2.idCardResponse,
        bookingRef: state.store2.booking_ref,
        checkinRoomNo: state.store2.checkin_room_no,
        confidenceScores: getConfidenceConfig(state),
        menuColor: state.store.home.MenuColor,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        selfieVideo: state.store2.selfieVideo,
        guestDetail: state.store.home.guestDetails,
        idCardResponse: state.store2.idCardResponse,
        selfieResponse: state.store2.selfieResponse,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        currentHomePage: state.store2.currentHomePage,
    }
}


export default connect(mapStateToProps,{ 
    setAutoCheckedIn, 
    setGoHome,
    setSelfieVideo,
    sendConfidenceScore
 })(withTranslation('translations')(BookingSuccess));